import * as API from '@/services/api';

export async function setDemoUserPassword(instanceToken, password) {
  const response = await API.post(`/api/demo/password/${instanceToken}`, {
    password,
  });
  return response.data;
}
